<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>
  <div class="divForm">
    <form [formGroup]="complementoForm" (ngSubmit)="submit()">
      <div class="form-group form-row">
        <mat-form-field appearance="outline" class="field-full">
          <mat-label>{{ translation?.Nombre }}</mat-label>
          <input
            matInput
            formControlName="Nombre"
            maxlength="100"
            (input)="onNombreInput($event)"
          />
          <mat-hint align="end"
            >{{ complementoForm.get('Nombre')?.value?.length || 0 }}/100</mat-hint
          >
          <mat-error *ngIf="validateFields('Nombre')">
            {{ getErrorMessage("Nombre") }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group form-row">
        <mat-form-field appearance="outline" class="field-full">
          <mat-label>{{ translation?.Descripcion }}</mat-label>
          <textarea
            matInput
            formControlName="Descripcion"
            rows="4"
            maxlength="255"
            (input)="onDescripcionInput($event)"
          ></textarea>
          <mat-hint align="end"
            >{{ complementoForm.get('Descripcion')?.value?.length || 0 }}/255</mat-hint
          >
          <mat-error *ngIf="validateFields('Descripcion')">
            {{ getErrorMessage("Descripcion") }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group form-row centros-dual-list-row">
        <mat-label class="centros-label">{{ translation?.Centros }}</mat-label>
        <customan-dual-list
          [listLabel]="''"
          [source]="centrosSinAsignar"
          [(destination)]="centrosAsignados"
          key="pkId"
          display="Nombre"
          [format]="format"
          [filter]="true"
          (emitMovedCentro)="onCentrosMoved()"
        >
        </customan-dual-list>
      </div>
    </form>
  </div>
</div>
